/* BRUUT - pre-launch. Telt af naar de openingsdatum en zet de koopknoppen op slot.
   De echte blokkade zit in Shopify zelf (voorraad 0 met registratie aan); dit is de uitleg eromheen. */
(function () {
  var root = document.querySelector('[data-plaunch]');
  if (!root) return;

  var cfg = {};
  try { cfg = JSON.parse(root.getAttribute('data-plaunch') || '{}'); } catch (e) { return; }

  var target = Date.parse(cfg.target);
  if (isNaN(target)) return;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function unit(value, label) {
    return '<span class="b-plu"><b>' + pad(value) + '</b><i>' + esc(label) + '</i></span>';
  }

  function markup(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    return unit(Math.floor(s / 86400), 'dagen') +
      unit(Math.floor(s / 3600) % 24, 'uur') +
      unit(Math.floor(s / 60) % 60, 'min') +
      unit(s % 60, 'sec');
  }

  // Zet elke koopknop op slot. Idempotent, zodat herhalen niets stukmaakt.
  function lock() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var btn = forms[i].querySelector('[type="submit"]');
      if (!btn || btn.getAttribute('data-pl') === '1') continue;
      btn.setAttribute('data-pl', '1');
      btn.disabled = true;
      btn.classList.add('b-btn--pre');
      btn.textContent = cfg.button || 'Binnenkort te bestellen';
    }

    var sold = document.querySelectorAll('.b-btn--sold');
    for (var j = 0; j < sold.length; j++) {
      if (sold[j].getAttribute('data-pl') === '1') continue;
      sold[j].setAttribute('data-pl', '1');
      sold[j].classList.add('b-btn--pre');
      sold[j].textContent = cfg.badge || 'Binnenkort';
    }
  }

  // Kaart met de aftelling boven de knop op de productpagina.
  function card() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form || !form.parentNode || document.querySelector('.b-plcard')) return;
    var el = document.createElement('div');
    el.className = 'b-plcard';
    el.innerHTML = '<p class="b-plcard__t">' + esc(cfg.pdp || 'Pre-orders openen over') +
      '</p><div class="b-plc" data-plc></div>';
    form.parentNode.insertBefore(el, form);
  }

  var timer;

  function opened() {
    clearInterval(timer);
    root.innerHTML = '<div class="b-wrap b-plb__in"><p class="b-plb__t">' +
      esc(cfg.opened || 'De pre-orders zijn open.') + '</p></div>';
    var c = document.querySelector('.b-plcard');
    if (c && c.parentNode) c.parentNode.removeChild(c);
  }

  function tick() {
    var left = target - Date.now();
    if (left <= 0) { opened(); return; }
    var html = markup(left);
    var slots = document.querySelectorAll('[data-plc]');
    for (var i = 0; i < slots.length; i++) slots[i].innerHTML = html;
    lock();
  }

  function start() {
    if (target - Date.now() <= 0) { opened(); return; }
    card();
    lock();
    tick();
    timer = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
